import { Container, ThemeProvider, Snackbar, Alert, Stack, Box } from '@mui/material';
import { MyAppBar } from "../components/Home/MyAppBar/myAppBar";
import { MainFooter } from "../components/Footer/mainFooter";
import { Hero } from "../components/Home/Hero/hero";
import { Features } from "../components/Home/Features/features";
import defaultTheme from '../components/Themes/defaultTheme';
import "../assets/css/main.css"
import { Faq } from '../components/Home/FAQ/faq';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Steps } from '../components/Home/Steps/steps';
import { Demo } from '../components/Home/Demo/demo';

export const Home = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    const donation = searchParams.get('donation');
    const subscription = searchParams.get('subscription');

    if (donation === 'success') {
      setSnackbar({
        open: true,
        message: 'Thank you for your donation! Your support means a lot to us.',
        severity: 'success',
      });
      // Clean up URL
      setSearchParams({});
    } else if (donation === 'cancelled') {
      setSnackbar({
        open: true,
        message: 'Donation was cancelled. No charges were made.',
        severity: 'info',
      });
      setSearchParams({});
    }

    if (subscription === 'success') {
      setSnackbar({
        open: true,
        message: 'Thank you for subscribing! Your monthly support helps us continue improving NodeCanvas.',
        severity: 'success',
      });
      setSearchParams({});
    } else if (subscription === 'cancelled') {
      setSnackbar({
        open: true,
        message: 'Subscription was cancelled. No charges were made.',
        severity: 'info',
      });
      setSearchParams({});
    }
  }, [searchParams, setSearchParams]);

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    if (props.scrollToFaq) {
      document.getElementById('faq').scrollIntoView({ behavior: 'smooth' });
    }
  }, [props.scrollToFaq]);

  useEffect(() => {
    if (props.scrollToDemo) {
      document.getElementById('demo').scrollIntoView({ behavior: 'smooth' });
    }
  }, [props.scrollToDemo]);

  useEffect(() => {
    if (props.scrollToFeatures) {
      document.getElementById('features').scrollIntoView({ behavior: 'smooth' });
    }
  }, [props.scrollToFeatures]);

  return (
    <>
    <ThemeProvider theme={defaultTheme}>
      <MyAppBar/>
      <Container
        id="home"
        disableGutters
        maxWidth="lg"
        component="main"
        sx={{
          pt: { xs: 4, sm: 6 },
          pb: { xs: 8, sm: 12 },
          px: { xs: 2.5, sm: 0 }
        }}
      >
        <Stack spacing={{ xs: 6, sm: 8 }}>
          <Box component="section">
            <Hero />
          </Box>
          <Box component="section">
          <Features />
          </Box>
          <Box component="section">
          <Demo />
          </Box>
          <Box component="section">
          <Steps />
          </Box>
          {/* <Box component="section">
            <PublicProjectsSection />
          </Box> */}
          <Box component="section">
            <Faq/>
          </Box>
          {/* <Box component="section">
            <GetStarted />
          </Box> */}
          <Box component="footer">
            <MainFooter />
          </Box>
        </Stack>
      </Container>
      </ThemeProvider>
      {/* <Container maxWidth="md" component="main">
        <ContactUs />
      </Container> */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};